import { Link } from "react-router-dom";
import { categories } from "../data/machines";

export default function Categories() {
  return (
    <div className="max-w-7xl mx-auto py-12 px-6">
      <h1 className="text-4xl font-bold text-center mb-10">Paper Machine Categories</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {categories.map(cat => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="border rounded-xl shadow hover:shadow-xl overflow-hidden block"
          >
            <img src={cat.image} alt={cat.title} className="w-full h-48 object-cover" />
            <div className="p-5">
              <h2 className="text-xl font-bold">{cat.title}</h2>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
